/**
 * Operator UI uses human percentages (50 = 50%).
 * API / DB continue to use integer basis points (5000 = 50%).
 * Precision: 0.01% (1 bps), matching backend min:1 max:10000.
 */

export const MIN_PERCENT = 0.01;
export const MAX_PERCENT = 100;
export const MIN_BPS = 1;
export const MAX_BPS = 10000;

/**
 * @param {string|number} percent
 * @returns {number} integer basis points
 */
export function percentToBps(percent) {
  const n = typeof percent === 'string' ? Number(String(percent).trim().replace(',', '.')) : Number(percent);
  if (!Number.isFinite(n)) {
    throw new RangeError('invalid_percent');
  }
  const bps = Math.round(n * 100);
  if (bps < MIN_BPS || bps > MAX_BPS) {
    throw new RangeError('percent_out_of_range');
  }
  return bps;
}

/**
 * @param {string|number|null|undefined} bps
 * @returns {number|null} human percent
 */
export function bpsToPercent(bps) {
  if (bps == null || bps === '') return null;
  const n = Number(bps);
  if (!Number.isFinite(n)) return null;
  // Avoid binary float noise for common values (e.g. 12.5).
  return Math.round(n) / 100;
}

/**
 * @param {string|number} percent
 * @returns {boolean}
 */
export function isValidDiscountPercent(percent) {
  try {
    percentToBps(percent);
    return true;
  } catch {
    return false;
  }
}
